import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import PDPMobileStudioPhotoGalleryUI from './PDPMobileStudioPhotoGalleryUI';
const PDPMobileStudioPhotoGalleryInner = t0 => {
  const $ = _c(10);
  const {
    pdpIsModularBYOProduct: t1,
    linkTo,
    mode: t2,
    slug
  } = t0;
  const pdpIsModularBYOProduct = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData
  } = usePDPPhotos(null, slug);
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  if (photosLoading || basicDetailsLoading || pdpIsModularBYOProduct && modularPhotosData.loading) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  if (photosError || basicDetailsError) {
    return null;
  }
  const {
    studioPhotos,
    enableCrops,
    introVideoIds
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;
  const {
    name
  } = basicDetailsData;
  const t3 = basicDetailsData?.custom_properties?.campaign;
  const t4 = introVideoIds?.desktop;
  let t5;
  if ($[1] !== enableCrops || $[2] !== linkTo || $[3] !== mode || $[4] !== name || $[5] !== studioPhotos || $[6] !== t3 || $[7] !== t4 || $[8] !== viewGalleryImageEvent) {
    t5 = <PDPMobileStudioPhotoGalleryUI campaign={t3} enableCrops={enableCrops} introVideoId={t4} linkTo={linkTo} mode={mode} photos={studioPhotos} productName={name} viewGalleryImageEvent={viewGalleryImageEvent} />;
    $[1] = enableCrops;
    $[2] = linkTo;
    $[3] = mode;
    $[4] = name;
    $[5] = studioPhotos;
    $[6] = t3;
    $[7] = t4;
    $[8] = viewGalleryImageEvent;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
PDPMobileStudioPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string
};
const PDPMobileStudioPhotoGallery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <ReRenderOnMount><SuspenseWithLoader fallback={t0}><PDPMobileStudioPhotoGalleryInner {...props} /></SuspenseWithLoader></ReRenderOnMount>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobileStudioPhotoGallery;